(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────
     Collection page enhancements
     ───────────────────────────────────────────────────────── */

  function isCollectionPage() {
    return document.body.classList.contains('template-collection') ||
           document.body.classList.contains('template-search') ||
           document.querySelector('.product-list--collection');
  }

  /* ── Build toolbar: wraps existing sort/filter UI ── */
  function buildToolbar() {
    var hasSidebar = !!document.querySelector('.sidebar');
    var sortEl = document.querySelector('.collection-sorting');
    var tagFilterEl = document.querySelector('.collection-tags-filter');
    var grid = document.querySelector('.product-list--collection');

    if (!grid && !sortEl && !tagFilterEl && !hasSidebar) return;

    var contentWrapper = document.querySelector('.template-collection .container.content > .one-whole.column, .template-search .container.content > .one-whole.column');
    if (!contentWrapper) {
      contentWrapper = document.querySelector('.has-sidebar-option');
      if (contentWrapper) contentWrapper = contentWrapper.parentElement;
    }
    if (!contentWrapper) return;

    /* Don't double-build */
    if (document.querySelector('.toolbar')) return;

    var toolbar = document.createElement('div');
    toolbar.className = 'toolbar';

    /* Left side: filter toggle (mobile) + count pill */
    var left = document.createElement('div');
    left.style.cssText = 'display:flex;align-items:center;gap:12px;flex-wrap:wrap;';

    if (hasSidebar) {
      var filterBtn = document.createElement('button');
      filterBtn.type = 'button';
      filterBtn.className = 'pc-filter-toggle';
      filterBtn.setAttribute('aria-label', 'Open filters');
      filterBtn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 6h16M7 12h10M10 18h4"/></svg>' +
        '<span>Filters</span>' +
        '<span class="pc-filter-toggle__count" data-pc-filter-count></span>';
      left.appendChild(filterBtn);
    }

    /* Product count intentionally hidden on collection pages.
       Search result counts are left untouched elsewhere. */
    toolbar.appendChild(left);

    /* Right side: sort + tag filter */
    var right = document.createElement('div');
    right.style.cssText = 'display:flex;align-items:center;gap:12px;flex-wrap:wrap;';

    if (tagFilterEl) right.appendChild(tagFilterEl);
    if (sortEl) right.appendChild(sortEl);
    toolbar.appendChild(right);

    /* Insert toolbar at the top of the content wrapper */
    var insertTarget = document.querySelector('.has-sidebar-option');
    if (insertTarget && insertTarget.parentNode) {
      insertTarget.parentNode.insertBefore(toolbar, insertTarget);
    } else {
      contentWrapper.insertBefore(toolbar, contentWrapper.firstChild);
    }
  }

  /* ── Mobile filter drawer ── */
  function setupMobileDrawer() {
    var sidebar = document.querySelector('.sidebar');
    if (!sidebar) return;

    var openBtn = document.querySelector('.pc-filter-toggle');
    if (!openBtn) return;

    /* Build drawer header & footer */
    function decorateDrawer() {
      if (sidebar.querySelector('.pc-drawer-head')) return;

      var head = document.createElement('div');
      head.className = 'pc-drawer-head';
      head.innerHTML =
        '<span class="pc-drawer-title">Filter &amp; Sort</span>' +
        '<button type="button" class="pc-drawer-close" aria-label="Close filters">×</button>';
      sidebar.insertBefore(head, sidebar.firstChild);

      var apply = document.createElement('div');
      apply.className = 'pc-drawer-apply';
      apply.innerHTML =
        '<button type="button" class="pc-drawer-clear">Clear all</button>' +
        '<button type="button" class="pc-drawer-show">Show results</button>';
      sidebar.appendChild(apply);

      head.querySelector('.pc-drawer-close').addEventListener('click', closeDrawer);
      apply.querySelector('.pc-drawer-show').addEventListener('click', closeDrawer);
      apply.querySelector('.pc-drawer-clear').addEventListener('click', function () {
        var clearLink = sidebar.querySelector('.faceted-active-filters__clear-all');
        if (clearLink) {
          window.location.href = clearLink.href;
        }
      });
    }

    function openDrawer() {
      decorateDrawer();
      sidebar.classList.add('is-mobile-open');
      var overlay = document.createElement('div');
      overlay.className = 'pc-drawer-overlay';
      overlay.addEventListener('click', closeDrawer);
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      sidebar.classList.remove('is-mobile-open');
      var overlay = document.querySelector('.pc-drawer-overlay');
      if (overlay) overlay.remove();
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', function () {
      if (window.innerWidth > 798) return;
      openDrawer();
    });

    /* Close on resize back to desktop */
    var prevWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      var w = window.innerWidth;
      if (prevWidth <= 798 && w > 798) closeDrawer();
      prevWidth = w;
    });
  }

  /* ── Update active filter count badge on the toggle button ── */
  function updateFilterCount() {
    var countEl = document.querySelector('[data-pc-filter-count]');
    if (!countEl) return;
    var actives = document.querySelectorAll('.faceted-active-filters__remove-filter');
    if (actives.length > 0) {
      countEl.textContent = actives.length;
    } else {
      countEl.textContent = '';
    }
  }

  /* ── Sticky toolbar on scroll (desktop) ── */
  function setupStickyToolbar() {
    if (window.innerWidth <= 798) return;
    var toolbar = document.querySelector('.toolbar');
    if (!toolbar) return;
    /* Optional sticky — leave off by default to avoid header overlap; can enable later */
    /* toolbar.classList.add('pc-toolbar-sticky'); */
  }

  /* ── Init ── */
  function init() {
    if (!isCollectionPage()) return;
    buildToolbar();
    setupMobileDrawer();
    updateFilterCount();
    setupStickyToolbar();

    /* Re-check filter count when filters change (Turbo's faceted updates) */
    var sidebar = document.querySelector('.sidebar');
    if (sidebar && 'MutationObserver' in window) {
      new MutationObserver(updateFilterCount).observe(sidebar, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// PROFUSION EDIT 2026-06-15: mobile overflow guard for collection/search pages
(function () {
  function fixMobileOverflow() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 798px)').matches) return;
    var page = document.querySelector('.pf-collection-page, .template-collection, .template-search, .template-list-collections');
    if (!page) return;

    document.documentElement.style.overflowX = 'hidden';
    document.body.style.overflowX = 'hidden';

    var vw = document.documentElement.clientWidth || window.innerWidth;
    var selectors = [
      '.pf-collection-page .section_select',
      '.pf-collection-page select',
      '.pf-collection-page .container',
      '.pf-collection-page .columns',
      '.pf-collection-page .column',
      '.pf-collection-page .product-list',
      '.pf-collection-page .product-list--collection',
      '.pf-collection-page .feature-divider',
      '.pf-collection-page .breadcrumb_text'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.style.maxWidth = '100%';
        el.style.boxSizing = 'border-box';
        if (el.tagName === 'SELECT') {
          el.style.width = '100%';
          el.style.minWidth = '0';
        }
      });
    });

    document.querySelectorAll('.pf-collection-page *').forEach(function (el) {
      if (el.scrollWidth > vw + 4 && window.getComputedStyle(el).position !== 'fixed') {
        el.style.maxWidth = '100%';
        el.style.boxSizing = 'border-box';
        if (!el.closest('.flickity-enabled, .swiper, .slider, .carousel')) {
          el.style.overflowX = 'hidden';
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', fixMobileOverflow, { passive: true });
  window.addEventListener('load', fixMobileOverflow, { passive: true });
  window.addEventListener('resize', fixMobileOverflow, { passive: true });
})();

// PROFUSION EDIT 2026-06-15: compact mobile swatches with +X indicator
(function () {
  function compactMobileSwatches() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 798px)').matches) return;
    var groups = document.querySelectorAll('.product-list--collection .collection_swatches, .product-list--collection .collection-swatches, .product-list--collection .collection-swatch, .template-collection .product-list .collection_swatches, .template-collection .product-list .collection-swatches, .template-collection .product-list .collection-swatch, .template-search .product-list .collection_swatches, .template-search .product-list .collection-swatches, .template-search .product-list .collection-swatch');
    groups.forEach(function (group) {
      if (group.dataset.pfSwatchCompacted === 'true') return;
      var children = Array.prototype.filter.call(group.children, function (el) {
        return !el.classList.contains('pf-swatch-more');
      });
      if (children.length > 5) {
        var more = document.createElement('span');
        more.className = 'pf-swatch-more';
        more.textContent = '+' + (children.length - 5);
        group.insertBefore(more, children[5] || null);
      }
      group.dataset.pfSwatchCompacted = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', compactMobileSwatches, { passive: true });
  window.addEventListener('load', compactMobileSwatches, { passive: true });
  document.addEventListener('shopify:section:load', compactMobileSwatches);
})();


// PROFUSION EDIT 2026-06-15: adaptive mobile filter/sort labels, no product-count pills
(function () {
  function cleanText(txt) {
    return (txt || '').replace(/\s+/g, ' ').trim();
  }

  function updateSelectState(field) {
    var select = field && field.querySelector('select');
    if (!select) return;
    var selected = select.options[select.selectedIndex];
    var text = cleanText(selected ? selected.textContent : '');
    var isFilter = field.classList.contains('pf-mobile-select-field--filter');
    var isDefaultFilter = isFilter && (/^all\s+/i.test(text) || text.toLowerCase().indexOf('all products') > -1 || text.toLowerCase().indexOf('all ') === 0);
    if (isDefaultFilter) text = 'All products';
    field.setAttribute('data-current', text);
    field.classList.toggle('is-active-selection', !!text && !isDefaultFilter);
  }

  function initAdaptiveControls() {
    document.querySelectorAll('.pc-count-pill, .pf-collection-count').forEach(function (el) {
      el.remove();
    });

    document.querySelectorAll('.pf-mobile-select-field').forEach(function (field) {
      updateSelectState(field);
      var select = field.querySelector('select');
      if (!select || select.dataset.pfAdaptiveReady === 'true') return;
      select.dataset.pfAdaptiveReady = 'true';
      select.addEventListener('change', function () {
        updateSelectState(field);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAdaptiveControls);
  } else {
    initAdaptiveControls();
  }

  document.addEventListener('shopify:section:load', initAdaptiveControls);
  if ('MutationObserver' in window) {
    new MutationObserver(function () { initAdaptiveControls(); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
